module.exports = __webpack_public_path__ + "img/bny-detail-6.14547824.png";